import { useOrganizationContext } from "../../context/organization_context/OrganizationContext";

const usePermissions = () => {
  const { organizationRoles, role } = useOrganizationContext()

  const hasPermission = (module, action) => {
    return organizationRoles?.[role]?.[module]?.[action];
  };

  return { hasPermission };
};

export default usePermissions;